<template>
  <v-row dense>
    <v-col cols="12" sm="3" md="3" lg="3">
      <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
        hide-details></v-text-field>
    </v-col>
    <v-col cols="12" sm="3" md="3" lg="3">
      <v-dialog ref="dialog" v-model="modal" :return-value.sync="selectedDates" width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
            v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
        </template>
        <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
          <v-spacer></v-spacer>
          <v-btn class="error-text-lighten-1" text @click.prevent="cancelSelection">
            Cancel
          </v-btn>
          <v-btn text @click.prevent="confirmSelection">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-col cols="12" sm="3" md="3" lg="3">
      <v-select solo :items="formatedAccountTypes" @change="handleAccount" item-value="id"
        item-text="account_type_display" append-icon="mdi-chevron-down" label="Account types"
        class="custom-select"></v-select>
    </v-col>
    <v-col cols="12" sm="3" md="3" lg="3">
      <ul>
        <li>
          <span>Total Profits:</span>
          <span>{{
            Number(live_trades_history?.totalProfit)?.toFixed(2)
          }} $</span>
        </li>
      </ul>
    </v-col>
    <v-col cols="12" sm="12">
      <v-card class="pa-0 rounded-0 elevation-0" :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'">
        <v-sheet class="transactionTable ib-commission-table"
          :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'">
          <v-data-table :items-per-page="10" :headers="headers" :search="search" :items="live_trades_history?.trades">
            <template v-slot:item.PriceOpen="{ item }">
              {{ item?.PriceOpen?.toFixed(2) }} $
            </template>
            <template v-slot:item.PriceCurrent="{ item }">
              {{ item?.PriceCurrent?.toFixed(2) }} $
            </template>
            <template v-slot:item.Profit="{ item }">
              {{ item?.Profit?.toFixed(2) }} $
            </template>
            <template v-slot:item.Volume="{ item }">
              {{ item?.Volume / 10000 }}
            </template>
            <template v-slot:item.TimeCreate="{ item }">
              {{ item?.TimeCreate }}
            </template>
            <template v-slot:item.Action="{ item }">
              {{
                item?.Action === 0 ? "Buy" : item?.Action === 1 ? "Sell" : null
              }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  TRADINGACCTYPES__ACTIONS,
  TRADINGHISTORY__ACTIONS,
} from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      selectedAccount: null,
      selectedDates: [],
      selectedDatesText: null,
      modal: false,
      headers: [
        { text: "Account", align: "start", value: "Login" },
        { text: "Ticket", value: "Position_ID" },
        { text: "Time", value: "TimeCreate" },
        { text: "Lots", value: "Volume" },
        { text: "Symbol", value: "Symbol" },
        { text: "Open Price", value: "PriceOpen" },
        { text: "Closed Price", value: "PriceCurrent" },
        { text: "Profit", value: "Profit" },
        { text: "Type", value: "Action" },
      ],
    };
  },

  computed: {
    ...mapState("tradingHistory", ["live_trades_history"]),
    ...mapState("accounttypes", ["accounttypes"]),

    formatedAccountTypes() {
      const accountNumbers = this.accounttypes.map((item) => {
        const { id, account_type_display } = item;
        return { id, account_type_display };
      });
      return ["All", ...accountNumbers];
    },
  },

  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },
    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        date: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
        account_type: Number(this.selectedAccount) || null,
      };

      this[TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS](parameter);
      this.modal = false;

      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
    ...mapActions("tradingHistory", [
      TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS,
    ]),

    ...mapActions("accounttypes", [TRADINGACCTYPES__ACTIONS.TRADINGACCTYPES]),

    handleAccount(selectedAccount) {
      this.selectedAccount = selectedAccount;
      const parameter = {
        date:
          this.startDateValue && this.endDateValue
            ? `${this.startDateValue.toISOString().split("T")[0]}to${this.endDateValue.toISOString().split("T")[0]
            }`
            : null,
        account_type: Number(this.selectedAccount) || null,
      };
      this[TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS](parameter);
    },
  },

  async mounted() {
    this[TRADINGHISTORY__ACTIONS.CLIENTLIVETRADESREPORTS]();
    this[TRADINGACCTYPES__ACTIONS.TRADINGACCTYPES]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>
